var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilityNavigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.739258C5.33646 0.739258 0.73999 5.33573 0.73999 10.9992C0.73999 16.6627 5.33646 21.2592 11 21.2592C16.6635 21.2592 21.2599 16.6627 21.2599 10.9992C21.2599 5.33573 16.6635 0.739258 11 0.739258ZM15.1347 11.543L12.0567 14.621C11.9028 14.7749 11.7079 14.8467 11.513 14.8467C11.318 14.8467 11.1231 14.7749 10.9692 14.621C10.6716 14.3235 10.6716 13.831 10.9692 13.5335L12.7339 11.7687H7.40898C6.98832 11.7687 6.63948 11.4199 6.63948 10.9992C6.63948 10.5786 6.98832 10.2297 7.40898 10.2297H12.7339L10.9692 8.46502C10.6716 8.16748 10.6716 7.675 10.9692 7.37746C11.2667 7.07993 11.7592 7.07993 12.0567 7.37746L15.1347 10.4555C15.4323 10.753 15.4323 11.2455 15.1347 11.543Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityNavigate);
export default __webpack_public_path__ + "static/media/facilityNavigate.9bf5718b28c6dd36537e15f7a826e946.svg";
export { ForwardRef as ReactComponent };